import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // Servicio simplificado para chat sin autenticación
  private isAccessAllowed = new BehaviorSubject<boolean>(true);
  public accessAllowed$: Observable<boolean> = this.isAccessAllowed.asObservable();

  constructor() {
    // Chat abierto para todos los usuarios
    this.isAccessAllowed.next(true);
  }

  // Método para verificar acceso (siempre true para chat público)
  hasAccess(): boolean {
    return true;
  }

  // Método para obtener estado de acceso
  getAccessStatus(): Observable<boolean> {
    return this.accessAllowed$;
  }
}